import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppointmentsTab from "../components/AppointmentTab";
import AccountsTab from "../components/AccountsTab";
import bg from "./DoctorDetails.jpg";

const DoctorProfile = () => {
  const { id } = useParams();
  const [doctor, setDoctor] = useState(null);
  const [activeTab, setActiveTab] = useState("appointments");

  // companies fetched from backend
  const [companies, setCompanies] = useState([]);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});

  // Delete button
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);

  // Fetch doctor details
  useEffect(() => {
    const fetchDoctorDetails = async () => {
      try {
        const res = await fetch(
          `https://backend-xhl4.onrender.com/DoctorRoute/${id}`
        );
        const data = await res.json();
        if (res.ok) {
          setDoctor(data);
          setEditData(data);
        } else {
          console.error("Doctor not found");
        }
      } catch (error) {
        console.error("Error fetching doctor:", error);
      }
    };

    fetchDoctorDetails();
  }, [id]);

  // Fetch companies from backend
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await fetch(
          "https://backend-xhl4.onrender.com/corporateroute/companies/dropdown"
        );
        const data = await res.json();
        if (res.ok) {
          setCompanies(data);
        }
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    fetchCompanies();
  }, []);

  // Save Updated Doctor
  const handleSave = async () => {
    try {
      const res = await fetch(
        `https://backend-xhl4.onrender.com/DoctorRoute/update/${doctor._id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(editData),
        }
      );

      if (res.ok) {
        const data = await res.json();
        setDoctor(data.doctor);
        setEditData(data.doctor);
        setShowModal(false);
      } else {
        console.error("Update failed");
      }
    } catch (error) {
      console.error("Error updating:", error);
    }
  };

  if (!doctor)
    return (
      <p style={{ textAlign: "center", marginTop: "2rem" }}>
        Loading doctor profile...
      </p>
    );

  const handleDelete = async () => {
    setDeleting(true);

    try {
      const res = await fetch(
        `https://backend-xhl4.onrender.com/DoctorRoute/delete/${doctor._id}`,
        {
          method: "DELETE",

          headers: { "Content-Type": "application/json" },
        }
      );

      if (res.ok) {
        // navigate to doctors list
        window.location.href = "/Doctors";
      } else {
        console.error("Delete failed");
        setDeleting(false);
      }
    } catch (err) {
      console.error("Error deleting:", err);
      setDeleting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "2rem",
        display: "flex",
        justifyContent: "center",
        marginTop: "5%",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1000px",
          backgroundColor: "rgba(255,255,255,0.95)",
          padding: "2rem",
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
        }}
      >
        <h1
          style={{
            color: "#4285F4",
            textAlign: "center",
            fontWeight: "bold",
            marginBottom: "2rem",
          }}
        >
          Dr. {doctor.Name}'s Profile
        </h1>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            marginBottom: "10px",
          }}
        >
          <button
            onClick={() => setShowDeleteConfirm(true)}
            style={{
              padding: "10px 20px",
              backgroundColor: "red",
              color: "#fff",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontWeight: "bold",
              marginLeft: "10px",
            }}
          >
            Delete Therapist
          </button>

          <button
            onClick={() => setShowModal(true)}
            style={{
              padding: "10px 20px",
              backgroundColor: "#4285F4",
              color: "#fff",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Edit Details
          </button>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "1rem 2rem",
            marginTop: "2rem",
          }}
        >
          <p>
            <strong>Doctor ID:</strong> {doctor.id}
          </p>
          <p>
            <strong>Mobile:</strong> {doctor.Mobile}
          </p>
          <p>
            <strong>Age:</strong> {doctor.Age}
          </p>
          <p>
            <strong>Gender:</strong> {doctor.Gender}
          </p>
          <p>
            <strong>City:</strong> {doctor.City}
          </p>
          <p>
            <strong>Email:</strong> {doctor.Email}
          </p>

          <p>
            <strong>Qualification:</strong> {doctor.Qualification}
          </p>
          <p>
            <strong>Platform Type:</strong> {doctor.platformType}
          </p>
          <p>
            <strong>Role:</strong> {doctor.Role}
          </p>
          <p>
            <strong>Company Name:</strong> {doctor.CompanyName}
          </p>
          <p>
            <strong>Company Code:</strong> {doctor.CompanyCode}
          </p>
        </div>

        {/* TABS */}
        <div style={{ textAlign: "center", margin: "2rem 0" }}>
          <button
            onClick={() => setActiveTab("appointments")}
            style={{
              marginRight: "1rem",
              padding: "10px 20px",
              backgroundColor:
                activeTab === "appointments" ? "#4285F4" : "#e0e0e0",
              color: activeTab === "appointments" ? "#fff" : "#333",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            View Appointments
          </button>

          <button
            onClick={() => setActiveTab("accounts")}
            style={{
              padding: "10px 20px",
              backgroundColor: activeTab === "accounts" ? "#4285F4" : "#e0e0e0",
              color: activeTab === "accounts" ? "#fff" : "#333",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            View Accounts
          </button>
        </div>

        <div
          style={{
            backgroundColor: "#fff",
            padding: "1.5rem",
            borderRadius: "10px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
          }}
        >
          {activeTab === "appointments" && (
            <AppointmentsTab doctorId={doctor._id} />
          )}

          {activeTab === "accounts" && (
            <AccountsTab doctorId={doctor._id} doctorName={doctor.Name} />
          )}
        </div>
      </div>

      {/* ---------- EDIT MODAL ---------- */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "800px",
              background: "#fff",
              padding: "30px",
              borderRadius: "12px",
              boxShadow: "0 0 20px rgba(0,0,0,0.3)",
            }}
          >
            <h2
              style={{
                textAlign: "center",
                color: "#4285F4",
                marginBottom: "20px",
              }}
            >
              Edit Doctor Details
            </h2>

            {/* 2 COLUMN HORIZONTAL GRID */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
              }}
            >
              {/* LEFT COLUMN */}
              <div>
                <label>Name</label>
                <input
                  value={editData.Name}
                  onChange={(e) =>
                    setEditData({ ...editData, Name: e.target.value })
                  }
                  style={inputStyle}
                />

                <label>Mobile</label>
                <input
                  value={editData.Mobile}
                  onChange={(e) =>
                    setEditData({ ...editData, Mobile: e.target.value })
                  }
                  style={inputStyle}
                />

                <label>Email</label>
                <input
                  value={editData.Email}
                  onChange={(e) =>
                    setEditData({ ...editData, Email: e.target.value })
                  }
                  style={inputStyle}
                />
                <label>Age</label>
                <input
                  value={editData.Age}
                  onChange={(e) =>
                    setEditData({ ...editData, Age: e.target.value })
                  }
                  style={inputStyle}
                />

                <label>Doctor ID (readonly)</label>
                <input disabled value={editData.id} style={inputStyle} />

                <label>City</label>
                <input
                  value={editData.City}
                  onChange={(e) =>
                    setEditData({ ...editData, City: e.target.value })
                  }
                  style={inputStyle}
                />
              </div>

              {/* RIGHT COLUMN */}
              <div>
                <label>Qualification (readonly)</label>
                <input
                  disabled
                  value={editData.Qualification}
                  style={inputStyle}
                />

                <label>Role</label>
                <select
                  value={editData.Role}
                  onChange={(e) =>
                    setEditData({ ...editData, Role: e.target.value })
                  }
                  style={inputStyle}
                >
                  <option value="">Select Role</option>
                  <option value="Therapist">Therapist</option>
                  <option value="Consultant">Consultant</option>
                </select>

                <label>Platform Type</label>
                <select
                  disabled={doctor.platformType === "ngo"}
                  value={editData.platformType}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "corporate" || value === "ngo") {
                      setEditData({
                        ...editData,
                        platformType: value,
                        CompanyCode: editData.CompanyCode || "",
                        CompanyName: editData.CompanyName || "",
                      });
                    } else {
                      // Clear if moved away (marketplace)
                      setEditData({
                        ...editData,
                        platformType: value,
                        CompanyCode: "",
                        CompanyName: "",
                      });
                    }
                  }}
                  style={inputStyle}
                >
                  <option value="">Select Platform</option>
                  {doctor.platformType === "corporate" ? (
                    // 👇 ONLY option shown when already corporate
                    <>
                      <option value="corporate">Corporate</option>
                      <option value="ngo">NGO</option>
                    </>
                  ) : (
                    <>
                      <option value="marketplace">Marketplace</option>
                      <option value="corporate">Corporate</option>
                      <option value="ngo">NGO</option>
                    </>
                  )}
                </select>

                {/* Show company dropdown if doctor is corporate OR selected corporate */}
                {(doctor.platformType === "corporate" ||
                  doctor.platformType === "ngo" ||
                  editData.platformType === "corporate" ||
                  editData.platformType === "ngo") && (
                  <>
                    <label>
                      {editData.platformType === "ngo"
                        ? "Select NGO"
                        : "Select Company"}
                    </label>
                    <select
                      value={editData.CompanyCode}
                      onChange={(e) => {
                        const selected = companies.find(
                          (c) => c.companyCode === e.target.value
                        );

                        setEditData({
                          ...editData,
                          CompanyCode: selected.companyCode,
                          CompanyName: selected.companyName,
                        });
                      }}
                      style={inputStyle}
                    >
                      <option value="">Select Option</option>
                      {companies.map((company, index) => (
                        <option key={index} value={company.companyCode}>
                          {company.companyName}
                        </option>
                      ))}
                    </select>
                  </>
                )}
              </div>
            </div>

            {/* BUTTONS */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "30px",
              }}
            >
              <button
                onClick={() => setShowModal(false)}
                style={{
                  padding: "10px 25px",
                  backgroundColor: "#ccc",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>

              <button
                onClick={handleSave}
                style={{
                  padding: "10px 25px",
                  backgroundColor: "#4285F4",
                  color: "#fff",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteConfirm && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          <div
            style={{
              width: "400px",
              background: "#fff",
              padding: "25px",
              borderRadius: "12px",
              textAlign: "center",
              boxShadow: "0 0 20px rgba(0,0,0,0.3)",
            }}
          >
            <h2 style={{ marginBottom: "20px", color: "red" }}>
              Confirm Delete
            </h2>

            <p style={{ marginBottom: "25px" }}>
              Are you sure you want to delete <b>{doctor.Name}</b>? <br />
              This action cannot be undone.
            </p>

            {deleting ? (
              <p style={{ color: "red", fontWeight: "bold" }}>
                Deleting... Please wait
              </p>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <button
                  onClick={() => setShowDeleteConfirm(false)}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#ccc",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>

                <button
                  onClick={handleDelete}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "red",
                    color: "#fff",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// inline input style
const inputStyle = {
  width: "100%",
  padding: "8px",
  margin: "5px 0 10px 0",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

export default DoctorProfile;
